import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  OnDestroy} from "@angular/core";
import {Router, RoutesRecognized} from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/pairwise";

@Component({
  selector: "app-verify-code-sent-modal",
  templateUrl: "./verify-code-sent-modal.component.html",
  styleUrls: ["./verify-code-sent-modal.component.scss"]
})
export class VerifyCodeSentModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;
  public cancelUrl: string;
  public resendUrl: string;
  public modalRef;
  public modalTitle: string = "There are a few reasons why you may not have received your verification code";

  private options: NgbModalOptions = {
    backdrop: "static",
    windowClass: "verify-code-sent",
    container: "app-verify-code-sent-modal",
    size: "lg",
    keyboard: false
  };
  constructor(private modalService: NgbModal, public router: Router) {

  }

  ngOnInit() {
    this.cancelUrl = sessionStorage.getItem("verifyModalCancelUrl") || "patient-portal/verify";
    this.resendUrl = sessionStorage.getItem("verifyModalResendUrl") || "patient-portal/phone";
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.options);
    });
  }
  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  cancel() {
    this.router.navigate([this.cancelUrl]);
  }

  resend() {
    this.router.navigate([this.resendUrl]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/verify-code-sent-modal/verify-code-sent-modal.component.ts